"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@indigenux/design/components");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const AccordionItem = _ref => {
  let {
    id,
    children,
    onItemClick,
    isActive,
    headingText,
    ...rest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
    className: "toggle " + (isActive ? 'active' : ''),
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Link, {
      id: id,
      class: "toggle-title",
      onItemClick: onItemClick,
      children: headingText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: isActive ? '' : 'toggle-content',
      children: children
    })]
  });
};
var _default = exports.default = AccordionItem;